import React, { useState, useEffect, useRef } from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Tooltip from '@mui/material/Tooltip';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import PromptsTable from './tables/PromptsTable'
import endpoints, { getBackendUrl } from '../../endpoints';
import axios from 'axios';
import { useSelector, useDispatch } from 'react-redux'
import EditPromptModal from './modals/EditPromptModal'
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import ButtonGroup from '@mui/material/ButtonGroup';
import AddBoxIcon from '@mui/icons-material/AddBoxRounded';
import AddIcon from '@mui/icons-material/AddRounded';
import EditIcon from '@mui/icons-material/EditRounded';
import DeleteIcon from '@mui/icons-material/DeleteRounded';
import Confirmation from './modals/Confirmation';
import Warning from './modals/Warning';
import withAlert from '../../hoc/withAlerts'
import { promptsFormControlsStruct } from './struct/FormControls'
import { setHeader } from '../../redux/headerSlice'
import Grow from '@mui/material/Grow';


function Prompts(props) {
    const [fullList, setFullList] = useState(null)
    const [categories, setCategories] = useState([])
    const [category, setCategory] = useState()
    const categoryRef = useRef()
    const [dialogData, setDialogData] = useState(null)
    const [dialogType, setDialogType] = useState(null)
    const [deleteItem, setDeleteItem] = useState()
    const [warningText, setWarningText] = useState()
    
    const dispatch = useDispatch()

    useEffect(() => {
        getFullList()
        if (!props.embedded) {
            dispatch(setHeader({
                title: 'Prompts'
            }))
        }
    }, []);

    const token = useSelector((state) => state.auth.token)

    const getFullList = async () => {
        let uri = getBackendUrl(endpoints.prompts, token)

        try {
            let res = await axios.get(uri)
            setFullList(res.data.items)
            
            let selCat = false
            const data = []
            res.data.items.map((row) => {
                if (row.type == 'category') {
                    data.push({
                        id: row.id,
                        name: row.content,
                    })
                    
                    if (row.id == categoryRef.current.value) {
                        selCat = row
                    }
                }
            })
            if (!selCat && res.data.items.length) {
                selCat = res.data.items[0]
            }
            
            setCategories(data)
            setCategory(selCat)
        } catch (e) {
            setFullList([])
            showAlertError('Unknown Error - get Full List')
        }
    }
    
    const categoryOnChange = (e) => {
        const id = e.target.value
        const c = fullList.find((item) => (item.id == id))
        setCategory(c)
    }

    const showAlertError = (message) => {
        props.showAlert(message, 'error')
    }

    const showAlertSuccess = (message) => {
        props.showAlert(message, 'success')
    }
    
    const btnAddHandle = (type) => {
        setDialogType(type)
        setDialogData({
            type: type
        })
    }
    
    const btnEditHandle = (item) => {
        setDialogType(item.type)
        setDialogData(item)
    }
    
    const saveHandle = (data) => {
        setDialogData(null)
        getFullList()
    }

    const deleteHandle = async (response) => {
        if (response) {
            if (deleteItem.children && deleteItem.children.length) {
                setWarningText('You cannot delete a category if it contains prompts.')
            } else {
                let uri = getBackendUrl(endpoints.prompts_delete, token).replace('{id}', deleteItem.id)
                try {
                    await axios.delete(uri)
                    await getFullList()
                    showAlertSuccess('Item deleted successfully!')
                } catch (e) {
                    showAlertError('Unknown Error - delete Item')
                }
            }
        }
        setDeleteItem(null)
    }

    return (
        <Grow in={fullList ? true : false}>
            <Stack sx={{ maxWidth: 1200, margin: 'auto', overflow: 'hidden', marginTop: '8px' }}>
                <Stack spacing={2} direction="row" sx={{pb: 1}} justifyContent="space-between">
                    <FormControl variant="filled" sx={{minWidth:'300px', }} >
                        <InputLabel id="categoryLabel">Category</InputLabel>
                        <Select
                            fullWidth
                            labelId="categoryLabel"
                            name="category"
                            inputRef={categoryRef}
                            onChange={categoryOnChange}
                            value={category ? category.id : ''}
                        >
                        {categories.map((row) => (
                            <MenuItem key={row.id} value={row.id}>{row.name}</MenuItem>
                        ))}
                        </Select>
                    </FormControl>
                    <ButtonGroup sx={{paddingTop:1.5}}>
                        <IconButton color="primary" size="medium" onClick={() => {btnAddHandle('category')}}>
                            <Tooltip title="Add Category">
                                <AddIcon />
                            </Tooltip>
                        </IconButton>
                        <IconButton color="warning" disabled={category ? false : true} size="medium" onClick={() => {btnEditHandle(category)}}>
                            <Tooltip title="Edit Category">
                                <EditIcon />
                            </Tooltip>
                        </IconButton>
                        <IconButton color="error" disabled={category ? false : true} size="medium" onClick={() => {setDeleteItem(category)}}>
                            <Tooltip title="Delete Category">
                                <DeleteIcon />
                            </Tooltip>
                        </IconButton>
                    </ButtonGroup>
                    <Stack sx={{ flexGrow:1 }}>
                    </Stack>
                    <FormControl variant="standard" sx={{ paddingTop:1.5 }}>
                        <Button variant="contained" 
                            color="primary"
                            startIcon={<AddBoxIcon />}
                            onClick={ () => {btnAddHandle('prompt')} }
                            disabled={category ? false : true}
                        >
                            Add Prompt
                        </Button>
                    </FormControl>
                </Stack>
                <Stack>
                    <PromptsTable category={category}
                        btnEditHandle={(item) => {setDialogType('prompt'); setDialogData(item)}}
                        btnDeleteHandle={(item) => {setDeleteItem(item)}}
                    />
                </Stack>            
                <EditPromptModal 
                    dialogData={dialogData}
                    dialogType={dialogType}
                    category={category}
                    categories={categories}
                    onClose={ () => {setDialogData(null)} }
                    onSave={saveHandle}
                >
                </EditPromptModal>
                <Confirmation data={deleteItem} onResponse={deleteHandle} />
                <Warning text={warningText} onClose={() => {setWarningText(null)}} />
            </Stack>
        </Grow>
    );
}

export default withAlert(Prompts)